import React from 'react';

import { SVGComponentProps } from './svg.types';

const SortSVG = ({ size = '1em', fill = 'currentColor', ...otherSvgProps }: SVGComponentProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherSvgProps}
    >
      <rect x="1" y="2" width="12" height="2" rx="1" fill={fill} />
      <path
        d="M2.5 7C2.5 6.44772 2.94772 6 3.5 6H10.5C11.0523 6 11.5 6.44772 11.5 7C11.5 7.55228 11.0523 8 10.5 8H3.5C2.94772 8 2.5 7.55228 2.5 7Z"
        fill={fill}
      />
      <path
        d="M4.5 11C4.5 10.4477 4.94772 10 5.5 10H8.5C9.05228 10 9.5 10.4477 9.5 11C9.5 11.5523 9.05228 12 8.5 12H5.5C4.94772 12 4.5 11.5523 4.5 11Z"
        fill={fill}
      />
    </svg>
  );
};

export default SortSVG;
